import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import { useSelector } from "react-redux";
import CircularProgress from "../components/CircularProgress";
import ProtectedRoute from "../components/ProtectedRoute";
import AuthCallback from "../components/AuthCallback";
import { getEnv } from "../config";

const Home = lazy(() => import("../pages/home/Home"));
const Idecaba = lazy(() => import("../pages/institutional/idecaba/Idecaba"));
const Organitation = lazy(() =>
  import("../pages/institutional/organitation/Organitation")
);
const Regulations = lazy(() =>
  import("../pages/institutional/regulations/Regulations")
);
const OrganitationP = lazy(() =>
  import("../pages/institutional/organizationP/OrganitationP")
);
const Adhere = lazy(() =>
  import("../pages/institutional/adhere idecaba/Adhere")
);
const Visor = lazy(() => import("../pages/resources/visor/Visor"));
const CatalogOg = lazy(() => import("../pages/resources/catalog_og/CatalogOg"));
const Instructions = lazy(() =>
  import("../pages/resources/instructions/Instructions")
);
const GeoservicesPage = lazy(() =>
  import("../pages/resources/geoservices/GeoservicesPage")
);
const CreateGeoservicePage = lazy(() =>
  import("../pages/resources/geoservices/CreateGeoservicePage")
);
const EditGeoservicePage = lazy(() =>
  import("../pages/resources/geoservices/EditGeoservicePage")
);
const SearchResults = lazy(() => import("../components/SearchResult"));
const Contacto = lazy(() => import("../pages/contacto/Contacto"));
const NewsList = lazy(() => import("../pages/news/NewsList"));
const CreateNews = lazy(() => import("../pages/news/CreateNews"));
const EditNews = lazy(() => import("../pages/news/EditNews"));
const NewsDetail = lazy(() => import("../pages/news/NewsDetail"));
const UserAdministration = lazy(() =>
  import("../pages/users-config/UserAdministration")
);
const ProfileAdministration = lazy(() =>
  import("../pages/profiles-permission/ProfileAdministration")
);
const AccessDenied = lazy(() => import("../pages/access-denied/Access"));
const LoginFail = lazy(() => import("../pages/login-fail/LoginFail"));
const PageError = lazy(() => import("../pages/error/PageError"));
const PageErrorLogin = lazy(() => import("../pages/error/PageErrorLogin"));

function LoginRedirect() {
  const redirectUrl = `${
    getEnv("REACT_APP_EXTERNAL_LOGIN_URL")
      ? getEnv("REACT_APP_EXTERNAL_LOGIN_URL")
      : "https://identidad-gcaba-hml.apps.buenosaires.gob.ar/realms/open-id/protocol/openid-connect/auth"
  }?client_id=${
    getEnv("REACT_APP_VALOR_CLIENT_ID")
      ? getEnv("REACT_APP_VALOR_CLIENT_ID")
      : "jkt2sxnb-nikp-05hp-x7zt-NOC1310743"
  }&redirect_uri=${
    getEnv("REACT_APP_API_URL_REDIRECT")
      ? getEnv("REACT_APP_API_URL_REDIRECT")
      : "https://portal-web-idecaba-dev.gcba.gob.ar/"
  }auth/callback&response_type=code&scope=openid&state=generar-state`;
  React.useEffect(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  return null; // No renderiza nada ya que redirige inmediatamente
}

function AppRoutes() {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <Suspense fallback={<CircularProgress />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <LoginRedirect />
          }
        />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/Acceso-denegado" element={<AccessDenied />} />
        <Route path="/error-page" element={<PageError />} />
        <Route path="/error-page-Login" element={<PageErrorLogin />} />
        <Route path="/Logueo-Fallido" element={<LoginFail />} />
        <Route path="Institucional/IDECABA" element={<Idecaba />} />
        <Route path="Institucional/Organizacion" element={<Organitation />} />
        <Route path="Institucional/Normativas" element={<Regulations />} />
        <Route
          path="Institucional/Organismos-Participantes"
          element={<OrganitationP />}
        />
        {/* <Route path="Institucional/Adherirse-IDECABA" element={<Adhere />} /> */}
        <Route path="Recursos/Visor-de-Mapas" element={<Visor />} />
        <Route
          path="Recursos/Catalogo-de-Objetos-Geograficos"
          element={<CatalogOg />}
        />
        {/* <Route path="Recursos/Instructivos" element={<Instructions />} /> */}
        <Route path="Recursos/Geoservicios" element={<GeoservicesPage />} />

        <Route
          element={
            <ProtectedRoute
              funcionalidadesRequeridas={[
                "Crear Geoservicio",
                "Editar Geoservicio",
                "Ver Geoservicio",
                "Eliminar Geoservicio",
              ]}
            />
          }
        >
          <Route path="/crear-geoservicio" element={<CreateGeoservicePage />} />
          <Route
            path="/editar-geoservicio/:id"
            element={<EditGeoservicePage />}
          />
        </Route>

        {/*<Route path="Recursos/Instructivos" element={<Instructions />} />  */}
        <Route path="/Busqueda-Resultado" element={<SearchResults />} />
        <Route path="/Contacto" element={<Contacto />} />
        <Route path="/Novedades" element={<NewsList />} />
        <Route path="/Novedad/:id" element={<NewsDetail />} />

        <Route
          element={
            <ProtectedRoute
              funcionalidadesRequeridas={[
                "Crear Novedad",
                "Editar Novedad",
                "Ver Novedad",
                "Eliminar Novedad",
              ]}
            />
          }
        >
          <Route path="/Crear-Novedad" element={<CreateNews />} />
          <Route path="/Editar-Novedad/:id" element={<EditNews />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              funcionalidadesRequeridas={[
                "Crear Usuario",
                "Editar Usuario",
                "Ver Usuario",
                "Eliminar Usuario",
              ]}
            />
          }
        >
          <Route path="Seguridad/Usuarios" element={<UserAdministration />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              funcionalidadesRequeridas={[
                "Crear Perfil",
                "Editar Perfil",
                "Ver Perfil",
                "Eliminar Perfil",
              ]}
            />
          }
        >
          <Route
            path="Seguridad/Perfiles"
            element={<ProfileAdministration />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
